import { useContext, useState } from "react"

// Context
import { UserContext } from "../../../context/userContext"

//Styles
import myStyles from "../../../styles/assessments/AssessmentList.module.css"
import assessStyles from "../../../styles/assessments/Assessment.module.css"

//PrimeReact
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"

import { assessmentsApiCloneAssessmentPost } from "../assessmentsApi"
import { LogError } from "../../../helpers/logger"

export default function AssessmentClone({
  assessmentId,
  assessmentName,
  activeOrganizationId,
  activeOrganizationAlias,
  onClose,
  onCloned,
}) {
  const userCtx = useContext(UserContext)

  const [name, setName] = useState(assessmentName)
  const [isLoading, setIsLoading] = useState(false)

  const onClone = async () => {
    setIsLoading(true)
    try {
      const result = await assessmentsApiCloneAssessmentPost(
        userCtx.tokenAssessments,
        {
          assessmentId: assessmentId,
          clonedName: name,
          targetEnterpriseId: userCtx.session.user.enterprise_id,
          targetEnterpriseAlias: userCtx.session.user.enterprise_alias,
          targetOrganizationId: activeOrganizationId,
          targetOrganizationAlias: activeOrganizationAlias,
          userId: userCtx.session.user.staff_id,
          userAlias: userCtx.session.user.staff_alias,
        }
      )

      if (result) {
        onCloned()
      } else {
        userCtx.setNotificationError("Unable to clone assessments")
      }
    } catch (error) {
      LogError("Unable to clone assessment", error)
      userCtx.setNotificationError(
        "Unable to clone assessment, please see console for more information"
      )
      setIsLoading(false)
    }
  }

  return (
    <Dialog
      header={"Clone assessment"}
      visible={true}
      onHide={onClose}
      className={myStyles.filterDialog}
      closable={!isLoading}
    >
      <div className={myStyles.cloneLayout}>
        <div className={myStyles.cloneLayoutName}>Clone the assessment as:</div>
        <div className={myStyles.cloneLayoutNameInput}>
          <InputText
            value={name}
            onChange={(e) => {
              setName(e.target.value)
            }}
            className={myStyles.cloneTextInput}
            disabled={isLoading}
          />
        </div>
        <div className={myStyles.cloneLayoutButtons}>
          <Button
            label={"Clone"}
            type={"button"}
            onClick={() => {
              onClone()
            }}
            className={assessStyles.button}
            disabled={isLoading}
            loading={isLoading}
          />
          <Button
            label={"Cancel"}
            type={"button"}
            onClick={() => {
              onClose()
            }}
            className={assessStyles.button}
            disabled={isLoading}
          />
        </div>
      </div>
    </Dialog>
  )
}
